import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared/shared.module';
import {
  VisitReviewAddFormComponent,
  VisitReviewAddComponent,
  AboutSalonComponent,
  VisitReviewComponent,
  VisitReviewReplyFormComponent
} from '@app/visit-reviews/components';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule
  ],
  declarations: [
    VisitReviewAddComponent,
    VisitReviewAddFormComponent,
    VisitReviewComponent,
    AboutSalonComponent,
    VisitReviewReplyFormComponent
  ]
})
export class VisitReviewModule { }
